import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import SideStep from '../../Steps/SideSteps';
import RegistrationSteps from '../../RegistrationSteps';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import * as media from '../../../constants/mediaQueries';

const FAQPageRightPart = (props) => {
  const { selectedLocations } = props;

  return (
    <div className="col-md-3">
      <div className="row">

        <MediaQuery minWidth={media.SCREEN_MD_MIN}>
          <div className="col-sm-6 col-md-12">
            {(selectedLocations.length > 0) && <OrderForm noScroll />}
          </div>
        </MediaQuery>

        <div className="col-sm-6 col-md-12">
          <SideStep />
        </div>

        <div className="col-sm-6 col-md-12">
          <RegistrationSteps />
        </div>

      </div>
    </div>
  );
};

FAQPageRightPart.propTypes = {
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

FAQPageRightPart.defaultProps = {
  selectedLocations: [],
};

export default FAQPageRightPart;
